import { useState, useEffect } from 'react';
import { Sector, SectorCreatePayload, SectorUpdatePayload } from '../types';
import { sectorsService } from '../services/sectors.service';

export const useSectors = (activeOnly: boolean = true) => {
  const [sectors, setSectors] = useState<Sector[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadSectors = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await sectorsService.listSectors(activeOnly);
      setSectors(data);
    } catch (err: any) {
      setError(err.message || 'Failed to load sectors');
    } finally {
      setIsLoading(false);
    }
  };

  const createSector = async (payload: SectorCreatePayload): Promise<Sector | null> => {
    const result = await sectorsService.createSector(payload);
    await loadSectors();
    return result;
  };

  const updateSector = async (id: number, payload: SectorUpdatePayload): Promise<Sector | null> => {
    const result = await sectorsService.updateSector(id, payload);
    await loadSectors();
    return result;
  };

  const deleteSector = async (id: number): Promise<void> => {
    try {
      await sectorsService.deleteSector(id);
      await loadSectors();
    } catch (err: any) {
      setError(err.message || 'Failed to delete sector');
      throw err;
    }
  };

  useEffect(() => {
    loadSectors();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOnly]);

  return {
    sectors,
    isLoading,
    error,
    loadSectors,
    createSector,
    updateSector,
    deleteSector,
  };
};
